import CheckboxField from 'components/forms/checkboxField/CheckboxField';
import { Col, Row } from 'react-bootstrap';
import { getLanguageName } from 'i18n/i18n.utils';
import { useTranslation } from 'react-i18next';
import { LanguageCode } from 'i18n/internationalization.types';
import { LANGUAGES } from '../ManageLanguages.constants';
import { ManageLanguagesModalDescription } from '../ManageLanguagesModal.styles';

const ManageLanguagesFields = () => {
  const { i18n, t } = useTranslation();

  return (
    <>
      <ManageLanguagesModalDescription>
        {t('pageAutomations.common.manageLanguagesModal.description')}
      </ManageLanguagesModalDescription>
      <Row>
        {LANGUAGES.map((language) => (
          <Col key={language} md={5}>
            <CheckboxField
              key={language}
              name={`locales.${language}`}
              disabled={language === LanguageCode.EN}
            >
              {getLanguageName(i18n.language, language)}
            </CheckboxField>
          </Col>
        ))}
      </Row>
    </>
  );
};

export default ManageLanguagesFields;
